import { ArgTypes } from '../utils/ArgValidation';
import { checkTypesAndCast } from '../utils/CheckTypesAndCast';

export interface EnricherInputField {
  name: string
  type: string
  required: boolean
  description: string
}

export const argTypes = {
  name: ArgTypes.string,
  type: ArgTypes.string,
  required: ArgTypes.bool,
  description: ArgTypes.string,
} as const;

export const fromJSON = checkTypesAndCast<EnricherInputField, typeof argTypes>(argTypes);
export const argType = ArgTypes.object.withShape(argTypes);
